import React from "react";

const Footer = () => {
    return (
        <>
            <footer className="footer">
                <div className="text-center">
                    <p>© Portfolio - Developed & Designed by <strong>Roeland Quentin</strong></p>
                </div>
            </footer>
        </>
    )
}

export default Footer